// @flow
const hoListCheck = ({
  array, defaultElement,
}: {
  array: Array<string>,
  defaultElement: string,
}) => (element: string) => (array.includes(element) ? element : defaultElement);

export default hoListCheck;



// WEBPACK FOOTER //
// ./src/scripts/components/Closeable/hoListCheck.js